import { FontSizes } from '@/types/fontSize';
import { Text } from './Text';
import register from './register';

register(Text, {
	fontSizes: [{ label: 'unset', value: 'unset' } as const, ...FontSizes],
});
